import { createRouter, RouteRecordRaw,createWebHashHistory } from 'vue-router'
import Layout from "@/layout/index.vue";

// 引入组件
import employeeManager from "./modules/employee";
import customerManager from "./modules/customer";
import toiletManager from "./modules/toilet";
import toiletImagesManager from "./modules/toiletimage";
import appUserManager from "./modules/appuser";
import feedBackManager from "./modules/feedback";
interface extendRoute {
  hidden?:boolean
}

export const constantRoutes: Array<RouteRecordRaw&extendRoute> = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    hidden: true,
    meta: { title: '',}
  },
  {
    path: '/',
    name: 'layout',
    component: Layout,
    redirect: '/home',
    meta: { title: '工作台', icon: 'HomeFilled', role:['other']},
    children: [
      {
        path: '/home',
        component: () => import('@/views/home/index.vue'),
        name: 'home',
        meta: { title: '首页',icon:'HomeFilled', affix: true ,role:['other']}
      },
    ]
  },

]

// 异步组件
export const asyncRoutes = [
  {
    path: '/dataCount',
    component: Layout,
    redirect: 'noRedirect',
    name: 'dataCountManager',
    meta: {
      title: '',
      icon: 'DocumentCopy'
    },
    children: [
      {
        path: 'dataCount',
        component: () => import('@/views/dataCount/index.vue'),
        name: 'dataCount',
        meta: { title: '数据统计', noCache: true,icon: 'DocumentCopy'  }
      },
    ]
  },
  toiletImagesManager,
  toiletManager,
  appUserManager,
  feedBackManager,
  // customerManager,
  employeeManager
]
const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL), // history
  history: createWebHashHistory(), // hash
  routes:constantRoutes
})

export default router
